import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import About from "./pages/about/About";
import Recruiting from "./pages/recruit/Recruiting";
import ContactUs from "./pages/contact/ContactUs";
import LandingTomatoPage from "./pages/landingPage2/LandingTomatoPage";
import Items from "./pages/items/Items";
import News from "./pages/news/News";
import Shopping from "./pages/shopping/Shopping";
import PolicyPage from "./pages/policy/PolicyPage";
import useVeggieItems from "./customHooks/useVeggieItems";
import Information from "./pages/pdf/Information";

export default function App() {
  const {
    veggieData,
    title,
    onClickChangeVeggieData,
    onClickMobile,
    veggieItem,
  } = useVeggieItems();

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/vegetablesItem"
          element={
            <Items
              veggieData={veggieData}
              title={title}
              onClickChangeVeggieData={onClickChangeVeggieData}
              onClickMobile={onClickMobile}
              veggieItem={veggieItem}
            />
          }
        ></Route>
        <Route path="/information" element={<Information />} />
        <Route path="/news" element={<News />} />
        <Route path="/about" element={<About />} />
        <Route path="/recruit" element={<Recruiting />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/order" element={<Shopping />} />
        <Route path="/policy" element={<PolicyPage />} />
        <Route exact path="/corporate" element={<About />}></Route>
        <Route exact path="/" element={<LandingTomatoPage />} />

        <Route path="*" element={<LandingTomatoPage />} />
      </Routes>
    </BrowserRouter>
  );
}
